import type { Marker } from '@citiguide/shared';
import { toChatLocale } from './chatLocale';

/**
 * Title in the visitor's language, falling back to Spanish, then English, then any titled
 * language, then the id. The UI language key is mapped to the content key first (`se` -> `sv`).
 */
export function getMarkerTitle(marker: Marker, language: string): string {
  const content = marker.content ?? {};
  const pick = content[toChatLocale(language)]?.title || content.es?.title || content.en?.title;
  if (pick) return pick;
  const any = Object.values(content).find((c) => c?.title);
  return any?.title || marker.markerId;
}
